const en = {
  // Common
  ID_POPUP_BTN_CONFIRM: "Confirm",
  ID_POPUP_BTN_CANCEL: "Cancel",
  ID_POPUP_BTN_SAVE: "Save",
  ID_POPUP_BTN_DELETE: "Delete",
  ID_POPUP_BTN_REFUSAL: "Refuse",
  ID_POPUP_BTN_ACCEPT: "Accept",

  ID_CHAT_REPORT_POPUP_TITLE: "채팅 신고",
  ID_CHAT_REPORT_POPUP_USER: "신고 대상",
  ID_CHAT_REPORT_POPUP_REASON: "신고 사유",
  ID_CHAT_REPORT_CONFIRM: "Register",

  ID_VOICE_CHAT_REPORT_POPUP_TITLE: "보이스 채팅 신고",
  ID_VOICE_CHAT_REPORT_POPUP_USER: "신고 대상",
  ID_VOICE_CHAT_REPORT_POPUP_REASON: "신고 사유",
  ID_VOICE_CHAT_REPORT_POPUP_RECORD: "채팅 녹음",
  ID_VOICE_CHAT_REPORT_POPUP_RECORD_BTN: "녹음",
  ID_VOICE_CHAT_REPORT_POPUP_PLAY_BTN: "재생",

  ID_CHAT_BLOCK_POPUP_TITLE: `{blockUser}님의 모든 채팅을 차단할까요?`,
  ID_CHAT_BLOCK_POPUP_CONFIRM: "Block",

  ID_POST_DECLARE_CONTENT: "신고 내용",
  ID_POST_DECLARE_REASON: "신고 사유를 선택해 주세요.",
  ID_POST_DECLARE_CONTENT_PLACEHOLDER: "Please enter the content.",
  ID_POST_DECLARE_ADD_FILE: "파일 첨부",
  ID_POST_DECLARE_TITLE: "게시글 신고",
  ID_POST_DECLARE_SELECT_ALL: "All",

  ID_POST_DECLARE_SELECT_OBSCENT: "음란 및 선정적인 활동",
  ID_POST_DECLARE_SELECT_ABUSE: "지나친 욕설 및 타인 비하",
  ID_POST_DECLARE_SELECT_OUTFLOW: "개인정보유출",
  ID_POST_DECLARE_SELECT_ADVERTISI: "광고",
  ID_POST_DECLARE_SELECT_DOMINATION: "게시글 도배",
  ID_POST_DECLARE_SELECT_ETC: "기타 운영정책 위반 활동",

  ID_STUDIO_CREATE_NEW_PROJECT_FORMAT: `새 프로젝트{randomChar}`,
  ID_STUDIO_PROJECT_EDIT: "Change Name",
  ID_STUDIO_PROJECT_EDIT_CONFIRM_BUTTON: "Edit",

  ID_VOICE_CHAT_SETTING_TITLE: "Setting",
  ID_VOICE_CHAT_SETTING_SPEAKER: "Speaker",
  ID_VOICE_CHAT_SETTING_MIC: "Mic",
  ID_VOICE_CHAT_SETTING_TEST_BTN: "Test",
  ID_VOICE_CHAT_SETTING_TEST_ING_BTN: "종료",
  ID_VOICE_CHAT_SETTING_TEST_PLAY_BTN: "재생중",
  ID_VOICE_CHAT_SETTING_SPEAKER_PLACEHOLDER: "스피커가 없습니다",
  ID_VOICE_CHAT_SETTING_MIC_PLACEHOLDER: "마이크가 없습니다",

  ID_POST_DECLARE_SUCSESS_TITLE: "신고 접수 되었습니다.",

  ID_WORLDPLAY_EXIT: "Would you like to end the play and go back to the main world?",

  ID_DEMO_PLAY_EXIT: "월드에서 나갈까요?",
  ID_DEMO_PLAY_EXIT_CONFIRM: "네",
  ID_DEMO_PLAY_EXIT_CANCEL: "아니오",

  ID_GROUND_SELECT_POPUP_TITLE: "Ground Select",

  ID_ASSET_ITEM_DELETE_POPUP_TITLE: "개의 항목을 삭제할까요?",

  ID_PRESET_TITLE: "My avatar settings",
  ID_PRESET_DESCRIPTION: "Choose your favorite avatar.\nAfter selecting an avatar, you will move to the Redbrick world.",
  ID_PRESET_BUTTON: "Start",
  ID_PRESET_SKIP: "Skip",
  ID_PRESET_CLOSE: "Close",

  ID_POPUP_OUT: "Close",
  ID_POPUP_KEEP: "Continue",

  ID_CODE_ERROR_TITLE: "Incorrect!",
  ID_CODE_ERROR_CONTENT: "You entered the wrong code\nor didn't complete all the missions.",
  ID_CODE_COMPLETE: "Congratulations!",
  ID_CODE_COMPLETE_CONTENT: "Completed the {mission}.\nPlease enter your name and class!",

  ID_NAME_ENTER: "Enter your name",
  ID_CLASS_ENTER: "Enter your class",

  ID_CERTIFICATE_GETTING: "Getting a Certificate",

  ID_CERTIFICATE_TITLE: "Certificate",
  ID_CERTIFICATE_CONTENT: "Contents",
  ID_CERTIFICATE_DEC: "Your certificate has been issued as above",
  ID_CERTIFICATE_DOWNLOAD: "Download",
  ID_CERTIFICATE_PRINT: "Print",

  ID_PUBLISH_POPUP_TITLE_PLACEHOLDER: "Please enter the title.",
  ID_PUBLISH_POPUP_DESCRIPTION_PLACEHOLDER: "Please enter the description.",
  ID_PUBLISH_POPUP_PHONENUMBER_PLACEHOLDER: "Please enter your phone number.",
  ID_PUBLISH_POPUP_USER_CONSENT: "Consent to collection and use of personal information (required)", 
  ID_PUBLISH_POPUP_USER_CONSENT_DETAILED_INFO: 
  `
    Purpose of collection: Sending event gifts |
    Items collected: School name, phone number |
    Retention and use period: When withdrawing from the service
  `,

  ID_INFORMATION_POPUP_TITLE: "📣 Redbrick Studio UI Update",
  ID_INFORMATION_POPUP_CONTENT:
    "The Redbrick Studio UI will be changed to provide a better creative experience.\nBoth the Old version and the New version will be applied with the changed UI at 12 p.m. on August 25th. (Korea Standard Time)\n\nCheck the link below for more information.",
  ID_INFORMATION_POPUP_LINK_BTN: "See More",
  ID_INFORMATION_POPUP_CLOSE_BTN: "Close",
};

export default en;
